import { render, staticRenderFns } from "./component-row.vue?vue&type=template&id=159dd91a"
import script from "./component-row.vue?vue&type=script&lang=js"
export * from "./component-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports